<template>
  <component
    :is="rootTag"
    v-bind="rootBind"
    class="settings-row"
    :class="{ 'settings-row--danger': danger, 'settings-row--first': first, 'settings-row--last': last }"
    :disabled="disabled || null"
    @click="onClick"
  >
    <span class="settings-row__icon" :style="{ background: iconBg }">
      <SfIcon v-if="iconName" :name="iconName" :size="17" />
      <span v-else-if="emoji" class="settings-row__icon-glyph" aria-hidden="true">{{ emoji }}</span>
    </span>
    <span class="settings-row__label">{{ label }}</span>
    <span v-if="value" class="settings-row__value">{{ value }}</span>
    <span v-if="showsChevron" class="settings-row__chev" aria-hidden="true">
      <SfIcon name="chevron" :size="14" />
    </span>
  </component>
</template>

<script>
import SfIcon from "./SfIcon.vue";

export default {
  name: "SettingsRow",
  components: { SfIcon },
  props: {
    iconName: { type: String, default: "" },
    emoji: { type: String, default: "" },
    iconBg: { type: String, default: "rgba(120, 120, 120, 0.18)" },
    label: { type: String, required: true },
    value: { type: String, default: "" },
    showsChevron: { type: Boolean, default: false },
    danger: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    href: { type: String, default: "" },
    first: { type: Boolean, default: false },
    last: { type: Boolean, default: false },
  },
  emits: ["click"],
  computed: {
    rootTag() {
      return this.href ? "a" : "button";
    },
    rootBind() {
      if (!this.href) return { type: "button" };
      const external = /^https?:\/\//.test(this.href) || this.href.startsWith("mailto:");
      if (external) {
        return { href: this.href, target: "_blank", rel: "noopener noreferrer" };
      }
      return { href: this.href };
    },
  },
  methods: {
    onClick(e) {
      if (this.disabled) {
        e.preventDefault();
        return;
      }
      this.$emit("click", e);
    },
  },
};
</script>

<style scoped>
.settings-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 11px 14px;
  border: 0;
  background: transparent;
  color: var(--app-text);
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
}

.settings-row:hover:not(:disabled) {
  background: color-mix(in srgb, var(--app-text) 5%, transparent);
}

.settings-row:disabled {
  opacity: 0.55;
  cursor: default;
}

.settings-row--danger {
  color: #ef4444;
}

.settings-row__icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: white;
}

.settings-row__icon-glyph {
  font-size: 15px;
  line-height: 1;
}

.settings-row__label {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.settings-row__value {
  color: var(--app-text-muted);
  font-size: 13px;
  font-weight: 500;
}

.settings-row__chev {
  color: var(--app-text-muted);
  display: inline-flex;
  align-items: center;
}
</style>
